import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('walking-sun');
	// The sun's container is one column of a blockTwoColumns instance
	// (.block--two-cols) — the other column holds the taller scrolling
	// content that gives the sticky sun somewhere to walk. Trigger against
	// that shared wrapper, not the block's own column, since the column
	// itself is only as tall as the sticky image.
	const section = container ? container.closest('.block--two-cols') : null;

	if (!container || !section) {
		console.warn('[walking-sun] block must be placed inside a blockTwoColumns (.block--two-cols) column — missing container or wrapper, bailing');
		return;
	}

	// Below md the block keeps its original static GIF — this is what
	// disableAnimation() restores when resizing back down from desktop.
	const staticHTML = container.innerHTML;

	const frames = [
		'/images/walking-sun/sun-walk-1.svg',
		'/images/walking-sun/sun-walk-2.svg',
		'/images/walking-sun/sun-walk-3.svg',
		'/images/walking-sun/sun-walk-4.svg',
		'/images/walking-sun/sun-walk-5.svg',
	];

	const LOOPS = 3;
	const totalFrames = frames.length * LOOPS;

	let framesPreloaded = false;
	let trigger = null;

	const enableAnimation = () => {
		if (trigger) return;

		if (!framesPreloaded) {
			framesPreloaded = true;
			frames.forEach(src => { const i = new Image(); i.src = src; });
		}

		container.innerHTML = `<img id="walking-sun-frame" src="${frames[0]}" class="w-full h-auto" alt="Walking sun animation">`;
		const img = document.getElementById('walking-sun-frame');

		trigger = ScrollTrigger.create({
			trigger: section,
			start: 'top top',
			end: 'bottom bottom',
			scrub: true,
			onUpdate: (self) => {
				const frameIndex = Math.min(
					Math.floor(self.progress * totalFrames),
					totalFrames - 1
				);
				const src = frames[frameIndex % frames.length];
				if (img.src !== src) img.src = src;
			},
		});
	};

	const disableAnimation = () => {
		if (!trigger) return;
		trigger.kill();
		trigger = null;
		container.innerHTML = staticHTML;
	};

	const mql = window.matchMedia('(min-width: 768px)');
	const syncToBreakpoint = () => (mql.matches ? enableAnimation() : disableAnimation());

	// This DOMContentLoaded handler can itself run late enough that the
	// window 'load' event has already fired by the time we'd register a
	// listener for it — that listener would then never run. Sync
	// immediately in that case instead of waiting for an event that's
	// already happened. Later breakpoint crossings (the mql 'change'
	// listener below) always run well after load, so they don't need this
	// guard.
	if (document.readyState === 'complete') {
		syncToBreakpoint();
	} else {
		window.addEventListener('load', syncToBreakpoint);
	}

	// mql's own 'change' event only fires when matches actually flips, which
	// covers real resizing on its own — the plain 'resize' listener is a
	// cheap belt-and-suspenders backup, since syncToBreakpoint() no-ops via
	// the trigger/framesPreloaded checks when nothing's actually changed.
	mql.addEventListener('change', syncToBreakpoint);
	window.addEventListener('resize', syncToBreakpoint);
});
